/**
 * Outbound customer email pattern (sales rework Phase 7, decision §0.8):
 * the CRM never sends customer email itself — it opens the user's OWN email
 * client pre-filled (to / subject / body) with the CRM inbox CC'd, so the
 * outbound copy AND any customer Reply-All land back in the CRM Inbox.
 * mailto: cannot carry attachments, so callers download the document(s)
 * alongside opening the draft (the user attaches manually).
 */

// mailto: URLs get truncated by some clients around ~2000 chars — cap the
// body politely rather than risk a silently cut-off draft.
const BODY_CAP = 1800;

export function buildMailtoHref({ to, cc, subject, body }) {
  const params = new URLSearchParams();
  if (cc) params.set('cc', cc);
  if (subject) params.set('subject', subject);
  if (body) {
    const capped = body.length > BODY_CAP
      ? `${body.slice(0, BODY_CAP)}\n\n[Draft truncated — please complete before sending]`
      : body;
    params.set('body', capped);
  }
  // URLSearchParams encodes spaces as '+', which mail clients render literally
  // — re-encode to %20.
  const queryString = params.toString().replace(/\+/g, '%20');
  return `mailto:${encodeURIComponent(to || '')}?${queryString}`;
}

export function openDraft(draft) {
  window.location.href = buildMailtoHref(draft);
}

export default buildMailtoHref;
